/* ============================================
   BBC WISHLIST — localStorage-based wish list
   ============================================ */
(function () {
  'use strict';

  var KEY = 'bbc-wishlist-v1';

  function getList() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function setList(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function isWished(id) { return getList().indexOf(String(id)) !== -1; }
  function toggle(id) {
    var list = getList();
    var sid = String(id);
    var idx = list.indexOf(sid);
    if (idx === -1) { list.push(sid); } else { list.splice(idx, 1); }
    setList(list);
    return list.indexOf(sid) !== -1;
  }

  /* Init heart buttons on product cards */
  function initHearts() {
    document.querySelectorAll('[data-wish-btn]').forEach(function (btn) {
      var id = btn.getAttribute('data-wish-btn');
      btn.setAttribute('aria-pressed', isWished(id) ? 'true' : 'false');
      btn.classList.toggle('is-wished', isWished(id));

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var wished = toggle(id);
        btn.setAttribute('aria-pressed', wished ? 'true' : 'false');
        btn.classList.toggle('is-wished', wished);
        btn.classList.add('bbc-wish-pop');
        setTimeout(function () { btn.classList.remove('bbc-wish-pop'); }, 400);
        window.dispatchEvent(new CustomEvent('bbc:wishlist:change', { detail: { id: id, wished: wished } }));
      });
    });
  }

  /* Init wishlist page if present */
  function initPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var list = getList();
    if (!list.length) {
      grid.innerHTML = '<p class="bbc-wl-empty">Votre liste de souhaits est vide.</p>';
      return;
    }
    var promises = list.map(function (id) {
      return fetch('/products.json?ids=' + id + '&limit=1')
        .then(function (r) { return r.json(); })
        .then(function (d) { return d.products && d.products[0]; });
    });
    Promise.all(promises).then(function (products) {
      grid.innerHTML = '';
      products.filter(Boolean).forEach(function (p) {
        var card = document.createElement('a');
        card.className = 'bbc-wl-card';
        card.href = '/products/' + p.handle;
        var img = p.images[0] ? '<img src="' + p.images[0].src + '" alt="' + p.title + '" loading="lazy">' : '';
        card.innerHTML = img +
          '<div class="bbc-wl-info"><p class="bbc-wl-vendor">' + (p.vendor || '') + '</p>' +
          '<p class="bbc-wl-title">' + p.title + '</p>' +
          '<p class="bbc-wl-price">' + formatMoney(p.variants[0].price) + '</p></div>';
        grid.appendChild(card);
      });
    }).catch(function () {
      grid.innerHTML = '<p class="bbc-wl-empty">Impossible de charger la liste.</p>';
    });
  }

  function formatMoney(cents) {
    return (parseInt(cents, 10) / 100).toFixed(2).replace('.', ',') + ' €';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initHearts(); initPage(); });
  } else {
    initHearts();
    initPage();
  }

  /* Re-init after Shopify section reload */
  document.addEventListener('shopify:section:load', function () { initHearts(); });
})();